import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 16 }) => (
  <span className="inline-flex items-center gap-0.5" aria-label={`${value} out of 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} className={n <= value ? "fill-[#E0A63C] text-[#E0A63C]" : "text-muted-foreground/30"} />
    ))}
  </span>
);
